import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { string, any } from 'prop-types';
import get from 'lodash/get';
import { TelevisionClassicIcon } from '../../atoms/material-icons';

import './live-tv.m.css';
import LivetvPlayer from '../../collection-templates/livetv-player';

export const LiveTvWidget = ({
  className,
  collection,
  publisherUrl,
  config,
  liveStreamUrl,
  liveTV,
  ...props
}) => {
  const [utmSource, setUtmSource] = useState('dailyhunt');

  useEffect(() => {
    try {
      const urlParams = new URLSearchParams(window?.location?.search);
      if (urlParams.get('utm_source')) {
        setUtmSource(urlParams.get('utm_source'));
      }
    } catch (e) {
      console.log('window.location.search is not defined');
    }
  }, []);

  return (
    <div styleName="live-tv-container">
      <div styleName="banner-container">
        <div styleName="headline-container">
          <div styleName="logo-container">
            <TelevisionClassicIcon size="20px" color="#fff" />
          </div>
          <a href={`https://www.ndtvprofit.com/live-tv?utm_source=${utmSource}`}>
            <h1 styleName="headline">
              LIVE TV
              <span>24/7 LIVE Stream</span>
            </h1>
          </a>
        </div>
        <div styleName="powered-by-container">
          <span>Powered by</span>
          <a href={`https://www.ndtvprofit.com?utm_source=${utmSource}`}>
            <img
              src="/icons/ndtv_group_white_logo.png"
              alt="ndtv-logo"
              width="118px"
              height="20px"
            />
          </a>
        </div>
      </div>
      <div styleName="react-player-container">
        <LivetvPlayer />
      </div>
    </div>
  );
};

LiveTvWidget.propTypes = {
  className: string,
  playList: any,
  publisherUrl: string.isRequired,
  liveStreamUrl: string,
};

const mapStateToProps = (state) => {
  return {
    config: get(state.qt, ['config'], {}),
    liveStreamUrl: get(
      state,
      ['qt', 'config', 'publisher', 'live_stream_url'],
      ['https://dai.google.com/linear/hls/event/QuU6z3GSTDaXuLL9Hs5A5Q/master.m3u8'],
    ),
    publisherUrl: state.qt.config['sketches-host'],
  };
};
